import { render, staticRenderFns } from "./withdrawCase.vue?vue&type=template&id=05493b34&scoped=true"
import script from "./withdrawCase.vue?vue&type=script&lang=js"
export * from "./withdrawCase.vue?vue&type=script&lang=js"
import style0 from "./withdrawCase.vue?vue&type=style&index=0&id=05493b34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05493b34",
  null
  
)

export default component.exports